import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * SHELUET — Selector de cantidad del carrito
 *
 * - El botón + aumenta normalmente.
 * - El botón - reduce normalmente.
 * - Si estamos en la cantidad mínima (normalmente 1),
 *   pulsar - manda cantidad 0 y elimina el producto.
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * En el carrito el máximo es absoluto.
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  /**
   * Gestiona los estados de + y -.
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Si Shopify ha deshabilitado completamente este selector,
    // mantenemos ambos botones deshabilitados.
    if (quantityInput.disabled) {
      minusButton.disabled = true;
      plusButton.disabled = true;
      return;
    }

    // SHELUET:
    // El "-" sigue activo cuando queda 1 para poder eliminar.
    minusButton.disabled = value <= 0;

    // El "+" respeta el máximo de inventario/cantidad.
    plusButton.disabled =
      effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Reduce cantidad.
   * Si estamos en el mínimo, elimina el producto enviando cantidad 0.
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();

    const { quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();

    // Si queda la cantidad mínima (normalmente 1),
    // pulsar "-" elimina la línea del carrito.
    if (value <= min) {
      quantityInput.value = '0';

      // Dispara el evento nativo de Horizon.
      // cart-items-component detectará quantity === 0
      // y eliminará el producto.
      this.onQuantityChange();
      return;
    }

    // Si hay más de una unidad, comportamiento normal.
    this.updateQuantity(-1);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}